var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container text-center"},[_c('div',{staticClass:"copyright"},[_vm._v(" © Posnet "+_vm._s(new Date().getFullYear())+" - v"+_vm._s(this.$appVersion)+" - Wykonanie: "),_c('a',{attrs:{"href":"https://sekafi.pl","target":"_blank"}},[_vm._v("Fiskas")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }